import request from '@/utils/request'

export function getMenus() {
  return request({
    url: '/Account/getRouter',
    method: 'get',
  })
}

export function getRoles() {
  return request({
    url: '/Account/getRoles',
    method: 'get',
  })
}

export function saveRole(data) {
  return request({
    url: '/Account/saveRole',
    method: 'post',
    data,
  })
}

export function syncRoute(data) {
  return request({
    url: '/Account/syncRoute',
    method: 'post',
    data,
  })
}

// export function updateRole(id, data) {
//   return request({
//     url: `/vue-element-admin/role/${id}`,
//     method: 'put',
//     data
//   })
// }

export function deleteRole(key) {
  return request({
    url: `/Account/deleteRole/${key}`,
    method: 'delete',
  })
}

export function getRoleMembers(query) {
  return request({
    url: '/Account/getRoleMembers',
    method: 'get',
    params: { query },
  })
}
